export class BaseAppService {

    constructor() {
        "ngInject";
    }
    
}



// WEBPACK FOOTER //
// ./src/app/base/base.app.service.ts